import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DndDirective } from './../../directivas/dnd.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetalleEspacioComponent } from './detalle-espacio/detalle-espacio.component';
import { ListarEspaciosComponent } from './listar-espacios/listar-espacios.component';
import { PaginaLugaresComponent } from './pagina-espacios/pagina-lugares.component';
import { LugaresRoutingModule } from './lugares-routing.module';
import { ComponentesCompartidosModule } from '../componentes-compartidos/componentes-compartidos.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { DetalleApartamentoComponent } from './detalle-apartamento/detalle-apartamento.component';
import { MatSelectModule } from '@angular/material/select';
import { HorarioComponent } from './horario/horario.component';
import { DetalleMiembroComponent } from './detalle-miembro/detalle-miembro.component';
@NgModule({
  imports: [
    CommonModule,
    ComponentesCompartidosModule,
    LugaresRoutingModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    PaginaLugaresComponent,
    DetalleEspacioComponent,
    ListarEspaciosComponent,
    DetalleApartamentoComponent,
    HorarioComponent,
    DndDirective,
    DetalleMiembroComponent
  ],
  exports: [
    PaginaLugaresComponent,
    ListarEspaciosComponent
  ]
})
export class LugaresModule { }
